<span style="float:left;padding-right:8px;margin-top:5px;"><button style="margin:0 0 0 5px;" pButton type="button" class="icon-action" icon="fa fa-th-list" (click)="op.toggle($event)"></button></span>

<p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true" appendTo="body" styleClass="overlay-offset">
    <div class="project-contract-menu">
  <p-tree [value]="contractTree" selectionMode="single" [style]="{'width':'100%'}" [styleClass]="'tree-container'" [(selection)]="selectedContract"
          (onNodeSelect)="onNodeSelect(selectedContract)">

  </p-tree>
</div>
</p-overlayPanel>


